import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryProvider } from './api/query';
import { ErrorFallback } from './components/ui/error-fallback';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import { registerChunkReloadHandler } from './utils/chunk-reload';

registerChunkReloadHandler();

const gtmId = import.meta.env.VITE_GTM_ID;
if (gtmId) {
  const script = document.createElement('script');
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `;
  document.head.appendChild(script);
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.25,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/hanly-api-dev\.fly\.dev\/api/,
    /^https:\/\/hanly-api-prod\.fly\.dev\/api/,
    /^https:\/\/internal-api\.animal-office\.jp\/api/,
  ],
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find the root element');
}

createRoot(container).render(
  <QueryProvider>
    <StrictMode>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={(error, info) => {
          Sentry.captureException(error, {
            extra: { componentStack: info?.componentStack },
          });
        }}
      >
        <App />
      </ErrorBoundary>
    </StrictMode>
  </QueryProvider>,
);
